module.exports = __webpack_public_path__ + "img/hk_feature4.22342929.jpg";